import { Directive, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Subject,  } from 'rxjs';

@Directive({
  selector: 'mat-select[appMatSelectFix]'
})
export class MatSelectFixDirective implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private isInitialLoadPeriod = true;
  
  @Input() initialLoadDuration = 3000; // 3 seconds default

  constructor(private matSelect: MatSelect) {}

  ngAfterViewInit() {
    // Set initial load period
    setTimeout(() => {
      this.isInitialLoadPeriod = false;
    }, this.initialLoadDuration);

    // Store original emit method
    const originalEmit = this.matSelect.selectionChange.emit.bind(this.matSelect.selectionChange);
    
    // Override the emit method
    this.matSelect.selectionChange.emit = (event: any) => {
      // Check if this is during initial load and isUserInput is false
      const isUserInput = this.getIsUserInput(event);
      
      if (!isUserInput && this.isInitialLoadPeriod) {
        // Create modified event with isUserInput = true
        const modifiedEvent = {
          ...event,
          isUserInput: true
        };
        originalEmit(modifiedEvent);
      } else {
        // Emit original event
        originalEmit(event);
      }
    };
  }

  private getIsUserInput(event: any): boolean {
    // Try different ways to access isUserInput
    if (event && typeof event.isUserInput !== 'undefined') {
      return event.isUserInput;
    }
    if (event && event.source && typeof event.source.isUserInput !== 'undefined') {
      return event.source.isUserInput;
    }
    return false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
